import { render } from "./TrainingSectionGalleryItem.vue?vue&type=template&id=746b132c&scoped=true"
import script from "./TrainingSectionGalleryItem.vue?vue&type=script&lang=js"
export * from "./TrainingSectionGalleryItem.vue?vue&type=script&lang=js"

import "./TrainingSectionGalleryItem.vue?vue&type=style&index=0&id=746b132c&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746b132c"]])

export default __exports__